import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { AuthService } from 'src/app/service/auth.service';
import { PerfilService } from 'src/app/service/perfil.service';
import { TarjetasService, ValidadorMAResponse } from 'src/app/service/tarjetas.service';


interface validaAMInt {
  apellidos: string
  correo: string
  descTipoTarjeta: string
  descripcion: string
  estadoMA: string
  mensaje: string
  nombres: string
  numABT: string
  numeroExterno: string
  numeroInterno: string
  resultado: string
  rut: string
  tecnologia: string
  tipotarjeta: string
  uidtarjeta: string
  uuidMovil: string
}

interface respService {
  servicio: object
}

@Component({
  selector: 'app-aside',
  templateUrl: './aside.component.html',
})
export class AsideComponent implements OnInit {
  @Output() loaded = new EventEmitter();
  @Output() solici = new EventEmitter();
  @Input() getData: any
  loading: boolean = true;

  nombre: string = '';
  cards: { cards: any[] } = { cards: [] };
  dataRes: any;
  ra: any;
  mandatos: any;
  cardSelected: any;
  session: any;
  standby: boolean = false;
  modalError: string = ''
  confirmDel: boolean = false;
  numTarjeta: string = '';
  loaderBtn: boolean = false;
  modalSuccess: string = '';


  formNewCard = new FormGroup({
    numTar: new FormControl('', Validators.required),
    nombre: new FormControl('', Validators.required)
  })

  constructor(
    private perfil: PerfilService,
    private route: Router,
    private tarjetas: TarjetasService,
    private cd: ChangeDetectorRef,
    private auth: AuthService
  ) {
    this.session = JSON.parse(localStorage.getItem('sesionPocae'))
    if (!localStorage.hasOwnProperty('nombre')) {
      this.loadPerfil()
    } else {
      this.nombre = localStorage.getItem('nombre');
    }


    this.tarjetas.currentTarjeta.subscribe(res => {
      let cards = res
      if (cards.cards?.length > 0) {

        this.cards = cards
        this.initData()
      } else {
        setTimeout(() => {

          this.loading = false;
        }, 1000)
      }

    })
    this.getCards()

  }

getSaldo(card: any) {
  if (card.saldo === undefined || card.saldo === null) {
    card.saldo = null;
  }

  const ksi = localStorage.getItem('KSI') || this.session?.ksi;
  const idUsuario = Number(localStorage.getItem('idUsuario') || JSON.parse(localStorage.getItem('sesionPocae') || '{}')?.idUsuario || this.session?.idUsuario || 0);

  const json = {
    sesion: {
      sIdSesion: ksi,
      nIdUsuarioWeb: idUsuario,
      nIdEmpresa: 5,
      sHost: "127.0.0.1"
    },
    numExterno: card.numTarjeta,
    numeroDias: 30
  };

  this.tarjetas.getTransaccionesAbt(json).pipe(take(1)).subscribe({
    next: (res: any) => {
      const servicio = (typeof res?.servicio === 'string') ? JSON.parse(res.servicio) : (res?.servicio ?? res);
      let saldoValue = null;
      if (servicio) {
        if (servicio.estado === -120) saldoValue = 0;
        else if (servicio.saldo != null) saldoValue = Number(servicio.saldo);
        else if (servicio.saldoDisponible != null) saldoValue = Number(servicio.saldoDisponible);
      }

      card.saldo = (saldoValue !== null && !isNaN(saldoValue)) ? saldoValue : null;

      try { this.cd.detectChanges(); } catch (e) { /* ok si no aplica */ }
    },
    error: (err) => {
      console.error('Error getTransaccionesAbt:', err);
      card.saldo = null;
      try { this.cd.detectChanges(); } catch (e) {}
    }
  });
}



  ngOnInit(): void {

  }

  getCards() {
  const json = {
    sesion: {
      sIdSesion: this.session.ksi,
      nIdUsuarioWeb: this.session.idUsuario,
      nIdEmpresa: 5,
      sHost: "127.0.0.1"
    },
    nIdUsuarioWeb: this.session.idUsuario
  };

  this.loading = true; 
  this.tarjetas.getCards(json).subscribe({
    next: (resRaw: any) => {
      const res = (typeof resRaw === 'string') ? JSON.parse(resRaw) : resRaw;
      const list = res?.resumenCols ?? res?.resumenTarjetas ?? res?.data ?? [];

      const tarjetasArr = Array.isArray(list) ? [...list] : [];

      this.cards.cards = tarjetasArr;
      this.cards.cards.forEach(c => this.getSaldo(c));
      this.tarjetas.addCards(tarjetasArr);

      // si había tarjetas inicializar primera vista
      if (this.cards.cards.length > 0) {
        this.initData();
      } else {
        // si no hay tarjetas, limpiar selección y standby
        this.cardSelected = null;
        this.standby = true;
      }
      try { this.cd.detectChanges(); } catch(e) {}

      this.loading = false;
    },
    error: (err) => {
      console.error('Error getCards:', err);
      this.modalError = 'Error al obtener medios de acceso.';
      this.loading = false;
    }
  });
}


  loadPerfil() {
    let json = {
      sesion: {
        sIdSesion: this.session.ksi,
        nIdUsuarioWeb: this.session.idUsuario,
        nIdEmpresa: 5,
        sHost: "127.0.0.1"
      },
      nIdUsuarioWeb: this.session.idUsuario
    }
    this.perfil.loadUser(json).subscribe(res => {
      this.nombre = res.sNombre;
      localStorage.setItem('nombre', this.nombre);
    })
  }

  initData() {
    this.cards.cards = this.tarjetasOrdenadas();
    if (!this.standby) {
      this.standby = true;
      this.dataResumen(0);
    }
  }

  openModalDel(num) {
    this.confirmDel = true;
    this.modalError = '';
    this.numTarjeta = num
  }

  delete() {
  this.loaderBtn = true;
  this.modalError = '';
  this.modalSuccess = '';

  const json = {
    sesion: {
      sIdSesion: this.session.ksi,
      nIdUsuarioWeb: this.session.idUsuario,
      nIdEmpresa: 5,
      sHost: "127.0.0.1"
    },
    nIdUsuarioWeb: this.session.idUsuario,
    sNumTarjeta: this.cardSelected,
  };

  this.tarjetas.deleteCard(json).subscribe({
    next: (res: any) => {
      this.loaderBtn = false;
      const numErr = res?.estado?.numeroError ?? res?.estado;
      if (numErr === 0) {
        
        this.closeModal();

        this.cardSelected = null;

        this.getCards();

        this.modalSuccess = 'Tarjeta desafiliada con éxito';
        setTimeout(() => { this.modalSuccess = ''; }, 3000);

      } else {
        this.modalError = res?.estado?.mensajeError || 'Error al desafiliar tarjeta';
      }
    },
    error: (err) => {
      console.error('Error deleteCard:', err);
      this.loaderBtn = false;
      this.modalError = "Error al desafiliar tarjeta. Inténtelo más tarde.";
    }
  });
}


  dataResumen(index: number) {
  this.standby = true;
  this.loading = true;

  const card = this.cards.cards[index];
  this.getSaldo(card); // mantiene la llamada al saldo

  this.tarjetas.validacionMA(card.numTarjeta).subscribe({
    next: (res: any) => {
      // Normalizamos la respuesta por si vino como string
      const numeroInternoStr = res.numeroInternoStr ?? (res.numeroInterno ? String(res.numeroInterno) : null);

       if (numeroInternoStr) {
      localStorage.setItem('numInt', numeroInternoStr);
    } else {
      // fallback: si no lo tenemos, intenta usar numeroInterno normal (menos seguro)
      if (res.numeroInterno !== undefined && res.numeroInterno !== null) {
        localStorage.setItem('numInt', String(res.numeroInterno));
      }
    }

      // Construimos el objeto que quieras exponer en la vista
      this.dataRes = {
      card,
      estadoMA: res.estadoMA,
      descripcion: res.descripcion,
      numeroInterno: numeroInternoStr ?? res.numeroInterno,
      numeroExterno: res.numeroExterno,
      descTipoTarjeta: res.descTipoTarjeta,
      rut: res.rut
    };

      // persiste numeroInterno si está disponible
      // if (respuesta.numeroInterno !== undefined && respuesta.numeroInterno !== null) {
        // localStorage.setItem('numInt', String(respuesta.numeroInterno));
      // }

      // marca la tarjeta seleccionada en el servicio
      this.cardSelected = card.numTarjeta;
      this.tarjetas.selectCard(this.cardSelected);

      // emite que cargó
      this.loaded.emit(this.dataRes);

      this.standby = false;
      this.loading = false;

      try { this.cd.detectChanges(); } catch (e) { /* ignore */ }
    },
    error: (err) => {
      console.error('Error validacionMA:', err);
      this.loading = false;
      this.standby = false;
      // muestra mensaje al usuario si corresponde
    }
  });
}


  tarjetasOrdenadas() {
    const objetoSeleccionado = this.cards.cards.find(obj => obj.indFavorito === 'S');

    const index = this.cards.cards.indexOf(objetoSeleccionado);
    let listCards = this.cards.cards;
    if (index !== -1) {
      listCards.splice(index, 1);
      listCards.unshift(objetoSeleccionado);
    }

    return listCards
  }

  private formatData(res: any): ValidadorMAResponse {
  if (!res) return {} as ValidadorMAResponse;

  // si viene como string que contiene JSON
  if (typeof res === 'string') {
    try {
      const parsed = JSON.parse(res);
      return parsed as ValidadorMAResponse;
    } catch (e) {
      // si no es JSON, devolvemos al menos el mensaje crudo
      return { resultado: -1, mensaje: res } as ValidadorMAResponse;
    }
  }

  // si ya es objeto
  return res as ValidadorMAResponse;
}


  sendSolici() {
    this.solici.emit(true);
  }

  trackById(item: any) {
    return (item.numTarjeta);
  }

  addNewCard() {
  if (!this.session || !this.session.ksi || !this.session.idUsuario) {
    this.modalError = 'Sesión inválida. Por favor inicie sesión nuevamente.';
    return;
  }

  if(!this.formNewCard.valid) {
    this.modalError = 'Por favor complete todos los campos requeridos.';
    return;
  }

  this.loading = true;
  this.modalError = '';

  const nTarjeta = String(this.formNewCard.get('numTar').value || '');
  const nomTarjeta = String(this.formNewCard.get('nombre').value || '');

  const sesionPayload = {
    nIdEmpresa: this.session.idEmpresa ?? 5,
    sIdSesion: this.session.ksi,
    sHost: '127.0.0.1',
    nIdUsuarioWeb: this.session.idUsuario
  };

  const payloadNewCard = {
    sesion: sesionPayload,
    nIdUsuarioWeb: this.session.idUsuario,
    sNumTarjeta: nTarjeta,
    sEtiqueta: nomTarjeta,
    sIndFavorita: 'N',
    // aliases (opcionales) para compatibilidad
    idUsuarioWeb: this.session.idUsuario,
    numTarjeta: nTarjeta,
    etiqueta: nomTarjeta,
    indFavorita: 'N'
  };

  const payloadGetCards = {
    sesion: sesionPayload,
    nIdUsuarioWeb: this.session.idUsuario
  };


  this.tarjetas.validacionMA(nTarjeta).subscribe({
    next: (resValidRaw: any) => 
    {
      
      let resValid: any;
      try {
        resValid = (typeof resValidRaw === 'string') ? JSON.parse(resValidRaw) : resValidRaw;
      } catch (e) {
        console.warn('No se pudo parsear validacionMA, usando crudo', e);
        resValid = resValidRaw;
      }

      const resultado = resValid?.resultado ?? resValid?.Resultado ?? resValid?.estado?.numeroError ?? resValid?.result;
      
      if (String(resultado) !== '0') {
        this.modalError = 'Medio de acceso inválido';
        this.loading = false;
        return;
      }

this.tarjetas.newCard(payloadNewCard).subscribe({
  next: (resNew: any) => {
    const numErr = resNew?.estado?.numeroError ?? resNew?.estado;
    if (numErr === 0) {
      this.tarjetas.getCards(payloadGetCards).subscribe({
        next: (resCardsRaw: any) => {
  
          const resCards = (typeof resCardsRaw === 'string') ? JSON.parse(resCardsRaw) : resCardsRaw;
          const list = resCards?.resumenCols ?? resCards?.resumenTarjetas ?? resCards?.data ?? [];
          const tarjetasArr = Array.isArray(list) ? [...list] : [];

          this.cards.cards = tarjetasArr;
          this.initData();
          this.tarjetas.addCards(tarjetasArr);

          this.loading = false;
          this.route.navigate(['/pocae/resumen']);
        },
        error: (errCards) => {
          this.modalError = 'Tarjeta afiliada, pero falló la obtención de resumen de tarjetas.';
          this.loading = false;
        }
      });
    } else if (numErr === 999 || numErr === 500) {
      this.modalError = 'Medio de acceso ya se encuentra afiliado al usuario';
      this.loading = false;
    } else {
      this.modalError = resNew?.msjError || 'Error al afiliar medio de acceso';
      this.loading = false;
    }
  },
  error: (errNew) => {
    console.error('Error newCard:', errNew);
    this.modalError = 'Error al afiliar medio de acceso. Inténtelo más tarde.';
    this.loading = false;
  }
});

    },
    error: (errVal) => {
      console.error('Error validacionMA:', errVal);
      this.modalError = 'Error al validar medio de acceso. Inténtelo más tarde.';
      this.loading = false;
    }
  });
}


  closeSession() {
    this.auth.logout(true)
    this.route.navigate(['/'])
  }

  closeModal() {

    this.confirmDel = false;
  }

  // bloquear teclas que no sean dígitos o teclas de control
onlyNumber(event: KeyboardEvent) {
  const char = event.key;
  const allowedControlKeys = [
    'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'
  ];

  if(event.key == 'Dead'){
    event.preventDefault();
    return;
  }

  // permitir combinaciones como Ctrl+C, Ctrl+V (aunque pegado será bloqueado por paste handler)
  if (event.ctrlKey || event.metaKey) {
    return;
  }

  if (allowedControlKeys.includes(event.key)) {
    return;
  }

  // permitir solo dígitos 0-9
  if (!/^[0-9]$/.test(char)) {
    event.preventDefault();
  }
}

// bloquear pegado
onPaste(event: ClipboardEvent) {
  event.preventDefault();
  // opcional: mostrar notificación al usuario que el pegado está deshabilitado
  // console.log('Pegado deshabilitado: solo se permite escritura manual');
}

// bloquear drop (arrastrar/soltar)
onDrop(event: DragEvent) {
  event.preventDefault();
  // opcional: console.log('Drop deshabilitado');
}

// opcional: limpieza por si entra algo extraño (por ejemplo por autocompletado)
// esto es defensivo; no debería ser necesario si paste/drop están bloqueados
onInput(event: Event) {
  const input = event.target as HTMLInputElement;
  const cleaned = (input.value || '').replace(/\D+/g, '');
  if (input.value !== cleaned) {
    input.value = cleaned;
    this.formNewCard.get('numTar')?.setValue(cleaned);
  }
}

}
